import { render, staticRenderFns } from "./trustpilot-reviews.vue?vue&type=template&id=7f0e116f&scoped=true&"
import script from "./trustpilot-reviews.vue?vue&type=script&lang=js&"
export * from "./trustpilot-reviews.vue?vue&type=script&lang=js&"
import style0 from "./trustpilot-reviews.vue?vue&type=style&index=0&id=7f0e116f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e116f",
  null
  
)

export default component.exports